module.exports = __webpack_public_path__ + "img/grand-resort.1f69c329.jpg";